import type { Http } from '../http';
import { endpoints } from '../endpoints';
import type { RequestOptions } from '../types/common';
import type {
  RawCreateProductRequest,
  RawPlantSubProductListParams,
  RawPlantSubProductListResponse,
  RawProductListParams,
  RawProductListResponse,
  RawProductResponse,
} from '../types/product';

export function createProductApi(http: Http) {
  return {
    /** POST /api/v2/products — 상품 등록 */
    async create(data: RawCreateProductRequest): Promise<RawProductResponse> {
      const res = await http.post<RawProductResponse>(endpoints.product.base, data);
      return res.data;
    },

    /** GET /api/v2/products — 상품 목록 조회 */
    async getList(
      params?: RawProductListParams,
      options?: RequestOptions,
    ): Promise<RawProductListResponse> {
      const res = await http.get<RawProductListResponse>(endpoints.product.base, {
        params,
        signal: options?.signal,
      });
      return res.data;
    },

    /**
     * GET /api/v2/products/plant-sub — 발전소 구독 상품 목록.
     * `plantId` 만 넘기면 BE 가 자격(설비·기관유형) 필터와 요금 산정을 수행한다. 페이지네이션 없음(전량).
     */
    async getPlantSubList(
      params: RawPlantSubProductListParams,
      options?: RequestOptions,
    ): Promise<RawPlantSubProductListResponse> {
      const res = await http.get<RawPlantSubProductListResponse>(endpoints.product.plantSub, {
        params,
        signal: options?.signal,
      });
      return res.data;
    },

    /** GET /api/v2/products/{productId} — 상품 단건 조회 */
    async getById(productId: number, options?: RequestOptions): Promise<RawProductResponse> {
      const res = await http.get<RawProductResponse>(endpoints.product.byId(productId), {
        signal: options?.signal,
      });
      return res.data;
    },

    /** PATCH /api/v2/products/{productId}/activate — 상품 활성화 */
    async activate(productId: number): Promise<void> {
      await http.patch<void>(endpoints.product.activate(productId));
    },
  };
}
